/* eslint-disable import/prefer-default-export */
import fetch, { simpleFetch as fetcher } from '@api/fetchers';
import { getHost, getCMSHost } from '@utils/api-helper/host';

const defaultHost = getHost();
const CMSHost = getCMSHost();

export const getStaticData = (options = {}) =>
  fetcher(`${CMSHost}api/offline-centres/`, options);

export const getCities = () =>
  fetcher(`${defaultHost}v1/offline_centres/cities`);

export const getOfflineCentrePlans = (city) =>
  fetcher(
    `${defaultHost}v1/subscriptions/offline/list/?city_uid=${city}&upgrade=true`
  );

export const fetchS3SignInUrl = ({
  fileName,
  type = 0,
  uid = '',
  contentType
}) =>
  fetch(
    `${defaultHost}v1/s3_url/?objectName=${encodeURIComponent(
      fileName
    )}&type=${type}${uid ? `&uid=${uid}` : ''}${
      contentType ? `&contentType=${contentType}` : ''
    }`,
    { useCamelCase: false }
  );

export const fetchCentresTAndC = (slug = '') =>
  fetcher(`${CMSHost}api/centres-terms-and-conditions/${slug}`);
